import React from 'react'
import { IFaq } from '@et/types/Courses'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { renderSvg } from '@utils/genUtils'
import { svgs } from '@svg'
import { faqAnswerVariants,FaqAnswer,FaqCloseBtn, FAQItemC } from '@styles/modules/faqItemStyles'

interface IProps {
  textColor: string | undefined
  textActivatedColor: string | undefined
  itemIndex: number
  selectedItem: number | null
  handleClick: (itemIndex?: number | null) => void
}

function FaqItemC (props: IProps & IFaq) {
  const { handleClick, itemIndex, selectedItem, question, answer, textColor, textActivatedColor } = props

  function click (e: any) {
    // e.preventDefault()
    const element = e.target.tagName.toLowerCase()

    if (itemIndex === selectedItem && element === 'span') {
      handleClick()
    } else {
      handleClick(itemIndex)
    }
  }

  return (
    <FAQItemC
      textactivatedcolor={textActivatedColor}
      textcolor={textColor}
      onClick={click}
      isopen={itemIndex === selectedItem ? 'true' : 'false'}>
      <h3>
        <Caret isOpen={itemIndex === selectedItem}>{renderSvg(svgs.CaretRight)}</Caret>
        {question}
        <FaqCloseBtn isOpen={itemIndex === selectedItem} onClick={click}/>
      </h3>
      <FaqAnswer
        className={'answer-framer-motion'}
        textactivatedcolor={textActivatedColor}
        textcolor={textColor}
        isopen={itemIndex === selectedItem ? 'true' : 'false'}
        variants={faqAnswerVariants}
        animate={itemIndex === selectedItem ? 'open' : 'closed'}
      >
        <div dangerouslySetInnerHTML={{ __html: answer }}/>
      </FaqAnswer>
    </FAQItemC>
  )
}


const Caret = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 4px;
  left: -25px;
  width: 20px;
  height: 20px;
  transform: ${props => props.isOpen ? `rotate(90deg)` : `rotate(0)`};
  transition: transform .3s;
  svg{
    width: 100%;
  }
`


export default FaqItemC
